import { FC, useCallback } from 'react';
import { isDesktop } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getGameInfo, getUsername } from '../../store/selectors';
import Button from '../common/Button';
import Logo from '../Logo';
import {ReactSVG} from "react-svg";
import cn from "classnames";
import './styles.scss';

interface GameHeaderProps {
    onClose: () => void;
    isClubApp: boolean;
}

const GameHeader: FC<GameHeaderProps> = ({ onClose, isClubApp }) => {
    const { t } = useTranslation();

    const username = useSelector(getUsername);
    const gameInfo = useSelector(getGameInfo);

    const openDepositView = useCallback(() => {
        if (window && window.parent) {
            window.parent.postMessage({ type: 'OPEN_DEPOSIT_MODAL' }, '*');
        }
    }, [window]);

    return (
        <div className={cn("game-header")}>
            <div className="game-header--left">
                <Logo />
                {isDesktop && gameInfo?.name && gameInfo?.providerName && (
                    <div className="general-info">
                        {gameInfo.name} - {gameInfo.providerName}
                    </div>
                )}
            </div>
            {isDesktop && !isClubApp && (
                <>
                    <div className="game-header__username">{username}</div>
                    <Button onClick={openDepositView} className="game-header__deposit">
                        {t('deposit')}
                    </Button>
                </>
            )}
            <span className="game__close-icon" onClick={onClose}>
             <ReactSVG src="/static/images/home.svg"  onClick={() => onClose}/>
      </span>
        </div>
    );
};

export default GameHeader;
